export enum APIProgress {
  Init = 0,
  Requested = 1,
  Success = 2,
  Failed = 3,
}

export type APIState = {
  progress: APIProgress;
  error?: number | null;
  error_msg?: string | null;
};
